import { Theme } from "./StyleSheet";

const config: Config = {
  defaultLocale: "fa",
  defaultTheme: "light",
};

export type Config = {
  defaultLocale: string;
  defaultTheme: Theme;
};

export default config;
